"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslationDefaultFunction = void 0;
exports.getTranslationDefaultFunction = function (_a) {
    var environmentLabel = _a.environmentLabel;
    return function (key) {
        throw new Error("It is not possible to translate " + key + ". Translate function was not passed to the " + environmentLabel);
    };
};
//# sourceMappingURL=translationDefaultFunction.js.map